export const mutations = {
    setPosVenda(state, PosVenda) {
        state.posVenda = PosVenda
    },
    setPosVendas(state, PosVendas) {
        state.posVendas = PosVendas
    },
    addPosVenda(state, data){
        state.posVendas.push(data)
    },
    removePosVenda(state, data){
        let index = state.posVendas.map(x => x.id).indexOf(data.id);
        state.posVendas.splice(index, 1)
    },
    setModalCadastroPosVenda(state, status) {
        state.modalCadastroPosVenda = status
    },
    setModalVisualizarPosVenda(state, status) {
        state.modalVisualizarPosVenda = status
    },
    setModalExcluirPosVenda(state, status) {
        state.modalExcluirPosVenda = status
    },
    setModalFinalizarPosVenda(state, status) {
        state.modalFinalizarPosVenda = status
    },
}

export default {}